@for (widget of widgetData; track widget) {
  <div class="widget-dashboard">
    <div>{{ widget.name }}</div>
    <mat-slide-toggle
      color="primary"
      matTooltip="{{ 'ADMIN.PAGES.VISIBILITY' | translate }}"
      [checked]="true"
      [disabled]="true"
    ></mat-slide-toggle>
  </div>
}
